module.exports = __webpack_public_path__ + "img/stock2.ff5ee40a.png";